<template>
	<slot></slot>
</template>

<script setup lang="ts">
import {useAttrs} from "vue";
import {provideVirtualRoute} from "@/router/virtual/VirtualRouter.ts";

const props = defineProps<{
	path: string
}>();

defineOptions({ inheritAttrs: false });
const attrs = useAttrs();

provideVirtualRoute({
	getParam(name:string):string|undefined {
		const value = attrs[name];
		if (value == null) return undefined;
		return String(value);
	},

	getPath():string {
		return props.path;
	},

	getParamNames():string[] {
		return Object.keys(attrs);
	}
});
</script>

<style>

</style>